import styled from "styled-components";

const AdvertisingStyles = styled.div`
  .tariff_card {
    width: 200px;
    height: 31vh;
    position: fixed;
    right: 2%;
    top: 25%;
  }
`;
export default AdvertisingStyles;
